import httputil from "./api/util/http-util-crm";
import utils from "@/util/video-utils";
import EventBus from "@/util/event-bus";
import {LIST_EVENTS} from "@/const/list-events.enum";

export default class Auth {
  constructor(repo, http, APIBaseURL) {
    this.APIBaseURL = APIBaseURL;
    this.http = http;
    this.repo = repo;
  }

  async request(url, config) {
    let tokens = await this.getTokensFromRepoOrRefresh();
    if (tokens == null) {
      return httputil.errResult(401, "need to auth");
    }
    
    if (!config) {
      config = {};
    }
    if (!("headers" in config)) {
      config.headers = {};
    }
    config["headers"]["Authorization"] = "Bearer " + tokens.access;
    try {
      return await this.http.request(url, config);
    } catch (error) {
      return Promise.reject(httputil.processError(error));
    }
  }
    
  async getTokensFromRepoOrRefresh() {
    let tokens = this.getTokensFromRepo();
    
    if (!tokens) {
      return Promise.reject(httputil.errResult(401, "Need to auth"));
    }
    tokens = this.processTokensDate(tokens);
    let now = new Date().getTime() / 1000;
    // access token is active
    if (tokens && now < tokens.exp_access) {
      return tokens;
    }
    // refresh token expired
    if (tokens && now >= tokens.exp_refresh) {
      return Promise.reject(httputil.errResult(401, "Need to auth"));
    }
    try {
      return await this.updateTokensByRefreshToken(tokens.refresh);
    } catch (error) {
      return Promise.reject(error);
    }
  }
    
  storeTokensToRepo(tokens) {
    return this.repo.store("tokens", tokens);
  }
    
  getTokensFromRepo() {
    let tokens = this.repo.get("tokens");
    return tokens;
  }

  removeTokensFromRepo() {
    this.repo.remove("tokens");
  }
    
  processTokensDate(tokens) {
    return tokens;
  }
    
  async updateTokensByCredentials(formData) {
    try {
      let res = await this.getTokensByCredentials(formData);
      res = this.processTokensDate(res);
      this.storeTokensToRepo(res);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
    
  async getTokensByCredentials(formData) {
    try {
      let res = await this.postNoAuth(`${this.APIBaseURL}nuexams/token/`, {
        ...formData
      });
    
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
    
  async updateTokensByRefreshToken(token) {
    try {
      let res = await this.getTokensByRefreshToken(token);
      res = this.processTokensDate(res);
      this.storeTokensToRepo(res);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
    
  async getTokensByRefreshToken(token) {
    try {
      let res = await this.postNoAuth(`${this.APIBaseURL}nuexams/token/refresh/`, {
        refresh: token
      });
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  onUploadProgress(progressEvent) {
    const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total );
    EventBus.$emit(LIST_EVENTS.FILE_UPLOAD_PROGRESS, percentCompleted);
  }

  async get(url, config) {
    if (!config) {
      config = {};
    }
    config.method = "get";
    
    let res = await this.request(url, config);
    return res;
  }
    
  async post(url, data, config, noIndicator = false) {
    if (!config) {
      config = {};
    }
    config.method = "post";
    config.data = data;
    if (!noIndicator && utils.isFileExistsInFormData(data)) {
      config.onUploadProgress = this.onUploadProgress;
    }
    return this.request(url, config);
  }
    
  async put(url, data, config) {
    if (!config) {
      config = {};
    }
    config.method = "put";
    config.data = data;
    let res = await this.request(url, config);
    return res;
  }
    
  async delete(url, config) {
    if (!config) {
      config = {};
    }
    config.method = "delete";
    
    let res = await this.request(url, config);
    return res;
  }

  async login(formData) {
    let res = await this.postNoAuth(`${this.APIBaseURL}token/`,
      {
        ...formData
      })
    return res
  }

  async logout() {
    this.removeTokensFromRepo();
  }

  async getNoAuth(url, data, config) {
    if (!config) {
      config = {};
    }

    try {
      let res = await this.http.get(url, data, config);
      return res;
    } catch (error) {
      return Promise.reject(httputil.processError(error));
    }
  }

  async postNoAuth(url, data, config) {
    if (!config) {
      config = {};
    }
    try {
      let res = await this.http.post(url, data, config);
      return res;
    } catch (error) {
      return Promise.reject(httputil.processError(error));
    }
  }

  async putNoAuth(url, data, config) {
    let res = {};

    await this.http
      .put(url, data, config)
      .then(response => {
        res = response.data;
      })
      .catch(err => {
        res = httputil.processError(err);
      });

    return res;
  }
}
